import type { Messages } from '@lingui/core';

import { i18n } from '@lingui/core';

// Import and initialize messages at module load time
// This ensures i18n is ready before any component using Trans renders
import { messages as defaultMessages } from './locales/en/messages';

export const locales = {
  en: 'English',
  'pseudo-LOCALE': 'Pseudo (Testing)',
} as const;

export type LocaleCode = keyof typeof locales;

export const defaultLocale: LocaleCode = 'en';

// Pre-define locale loaders for Vite to analyze statically
const localeLoaders: Record<LocaleCode, () => Promise<{ messages: Messages }>> =
  {
    en: () => Promise.resolve({ messages: defaultMessages }),
    'pseudo-LOCALE': () => import('./locales/pseudo-LOCALE/messages.ts'),
  };

/**
 * Dynamically load and activate a locale.
 * Uses dynamic imports for code splitting.
 */
export async function dynamicActivate(locale: LocaleCode): Promise<void> {
  try {
    const loader = localeLoaders[locale];
    const { messages } = await loader();

    i18n.load(locale, messages);
    i18n.activate(locale);
  } catch (error) {
    console.error(`Failed to load locale "${locale}":`, error);

    // Fall back to default locale if loading fails and not already trying default
    if (locale !== defaultLocale) {
      console.warn(`Falling back to default locale "${defaultLocale}"`);
      await dynamicActivate(defaultLocale);
    }
  }
}

i18n.load(defaultLocale, defaultMessages);
i18n.activate(defaultLocale);

export { i18n };
